import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import CallTableViewModel from "../../../ViewModels/CallTableViewModel";
import FilterChipDisplay from "../../FilterChipDisplay";
import VOCDialog from "./VOCDialog";

interface IFiltersProps {
    callTableViewModel: CallTableViewModel
    setCallTableViewModel: (value: CallTableViewModel) => void
}

export default function VOCFilters({ callTableViewModel, setCallTableViewModel }: IFiltersProps) {
    const [open, setOpen] = useState(false);

    const text =
        <Typography variant="body1">
            {
                "Voice Of The Customer - "
            }
            {
                (callTableViewModel.filters.vocFilters.question != "") ?
                    callTableViewModel.filters.vocFilters.question + ' - ' + callTableViewModel.filters.vocFilters.answer
                    : ' Is Any'
            }
        </Typography>

    return (
        <>
            <FilterChipDisplay
                text={text}
                selectable
                onClick={() => setOpen(true)} />
            <VOCDialog
                open={open}
                setOpen={setOpen}
                callTableViewModel={callTableViewModel}
                setCallTableViewModel={setCallTableViewModel}
            />
        </>
    )
}